<template>
    <div>
            <v-row >
                <v-col v-for="image in images" :key="image.imageId" @click="selectImage(image)">
                <img :src="image.imageSrc" :alt="`Picture ${image.imageId}`" :class="{ selected: image.isSelected }">
                <label :for="`image-${image.imageId}`" class="image-label">{{ image.imageLabel }}</label>
                    </v-col>
            </v-row>
        <div v-if="selectedImageId !== null">
            <img :src="images.find(img => img.imageId === selectedImageId)?.imageSrc" :alt="`Picture ${selectedImageId}`" style="max-width: 200px;">
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                images: [],
                selectedImageId: null
            }
        },
        watch: {
            value: {
                handler(newImages) {
                    this.images = Array.isArray(newImages) ? newImages.map(img => ({ ...img })) : []
                    this.selectedImageId = null
                },
                immediate: true,
                deep: true
            }
        },
        methods: {
            selectImage(selectedImage) {
                this.images = this.images.map(image => ({
                    ...image,
                    isSelected: image.imageId === selectedImage.imageId
                }))
                this.selectedImageId = selectedImage.imageId

                // Emit the updated images list
                this.$emit('input', this.images)
            }
        }
    }

</script>

<style scoped>
    .options {
        display1: flex;
        justify-content: normal;
    }

        .options div {
            cursor: pointer;
            text-align: center;
            margin: 10px;
        }

        .options img {
            width: 100px;
            height: 100px;
            border-radius: 5px;
            transition: transform 0.2s;
        }

            .options img.selected {
                transform: scale(1.2);
                border: 2px solid var(--v-primary-base);
            }

    .image-label {
        display: block;
        margin-top: 5px;
        font-size: 14px;
        color: #555;
        font-weight: 700;
    }
</style>
